<template>
  <section>
    <notifications></notifications>

    <base-header>
      <div class="row align-items-center pt-header">
        <div class="col-lg-6 col-md-6 col-sm-6 col-4 d-flex align-items-center">
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>

          <h1 class="title-view">
            {{ $route.meta.title }}
          </h1>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-8 text-right">
          <div class="box-buttons">
            <base-button
              type="outline-neutral"
              class="min-button mr-2 no-mb"
              @click="mode = 'view'"
              v-if="mode === 'edit'"
            >
              <i class="flaticon-view-1 icon-no-margin"></i>
              <strong class="d-lg-block d-none">View</strong>
            </base-button>

            <base-button
              v-if="canUserUpdate && mode === 'view'"
              type="outline-neutral"
              @click="mode = 'edit'"
              class="min-button no-mb mr-2"
            >
              <i class="flaticon-pencil icon-no-margin"></i>
              <strong class="d-lg-block d-none">Edit</strong>
            </base-button>

            <base-button
              v-if="canUserUpdate && mode === 'edit'"
              type="primary"
              @click="saveReseller()"
              class="min-button no-mb"
            >
              <i class="flaticon-floppy-disk icon-no-margin"></i>
              <strong class="d-lg-block d-none">Save</strong>
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid profile mb-5 forms">
      <div class="row">
        <div class="col-xl-3 col-lg-12 col-md-12 col-sm-12 col-12">
          <div class="row justify-content-center">
            <div class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12">
              <div class="card">
                <div class="row justify-content-center">
                  <div class="col-lg-12 col-md-12 text-center pb-1">
                    <label
                      for="driver_ProfileImage"
                      class="title-label-np mb-2"
                      v-if="mode === 'edit'"
                    >
                      Profile Image
                      <el-popover
                        placement="top"
                        trigger="hover"
                        width="300"
                        class="curp"
                      >
                        <ul class="ul-pop">
                          <li>Allowed Dimensions: 500px x 500px</li>
                          <li>Maximum Size: 2MB</li>
                          <li>Allowed Formats: gif, jpg, jpeg, png</li>
                        </ul>
                        <div class="badge badge-primary" slot="reference">
                          ?
                        </div>
                      </el-popover>
                    </label>

                    <div class="imageload3">
                      <div class="image">
                        <div
                          v-if="customer.url_picture"
                          v-bind:style="{
                            backgroundImage: 'url(' + customer.url_picture + ')'
                          }"
                          class="imgprofile"
                        ></div>

                        <div
                          v-else
                          v-bind:style="{
                            backgroundImage: 'url(' + imageProfile + ')'
                          }"
                          class="imgprofile"
                        ></div>
                      </div>

                      <div class="contentfile3" v-if="mode === 'edit'">
                        <base-dropdown>
                          <base-button
                            slot="title-container"
                            type="primary"
                            class="dropdown-toggle btn-icon-only buttonfiles3"
                          >
                            <i class="flaticon-camera mr-0"></i>
                          </base-button>
                          <span class="dropdown-item">
                            <base-input
                              class="filebutton3"
                              type="file"
                              name="file-1"
                              id="file-1"
                              :accesskey="'profile'"
                              enctype="multipart/form-data"
                              accept="image/jpeg, image/jpg, image/png"
                              @change="readFile"
                            ></base-input>
                            Upload Image
                          </span>
                          <span
                            class="dropdown-item"
                            v-if="picture"
                            @click="clearfile()"
                            >Remove
                          </span>
                        </base-dropdown>
                      </div>
                    </div>

                    <div class="box-profile-one">
                      <h2
                        class="subtitle mb-1"
                        v-if="customer.type === 'travel_agency'"
                      >
                        {{ customer.company_name }}
                      </h2>
                      <h2 class="subtitle mb-1" v-else>
                        {{ customer.first_name }}
                        {{ customer.last_name }}
                      </h2>
                    </div>

                    <div class="d-inline-block mt-2 mb-3">
                      <div
                        class="badge-profile status-confirmed"
                        v-if="customer.status && customerStatus"
                      >
                        <i class="flaticon-check-2 text-success f25 mr-2"></i>
                        <span>Confirmed</span>
                      </div>

                      <div
                        class="badge-profile status-cancelled"
                        v-if="!customer.status && customerStatus"
                      >
                        <i class="flaticon-check-2 text-danger f25 mr-2"></i>
                        <span>No Confirmed</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12 box-flex">
              <div class="card">
                <h2 class="subtitle">Notes</h2>
                <div class="row">
                  <div class="col-12">
                    <div class="data-block" v-if="mode === 'view'">
                      <span class="content-block" v-if="customer.notes">{{
                        customer.notes
                      }}</span>
                      <span class="content-block" v-else>No notes here</span>
                    </div>

                    <div class="mb-4" v-if="mode === 'edit'">
                      <el-input
                        v-model="$v.customer.notes.$model"
                        placeholder="notes"
                        id="customer_notes"
                        name="customer_notes"
                        tabindex="23"
                        maxlength="200"
                        type="textarea"
                        :autosize="{ minRows: 2, maxRows: 10 }"
                        show-word-limit
                      >
                      </el-input>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-9 col-lg-12 col-md-12">
          <tabs
            tabNavClasses="tabs-home justify-content-around tab-profiles"
            :value="tabActive"
            @changeTabActive="changeTabActive"
          >
            <tab-pane id="Overview" title="Overview" ref="Overview">
              <div class="card">
                <h2 class="subtitle">Business Details</h2>
                <div v-if="mode === 'view'">
                  <div class="row">
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                      <div class="data-block">
                        <span class="title-block">Business Name</span>
                        <span class="content-block">{{
                          customer.company_name
                        }}</span>
                      </div>
                    </div>

                    <div
                      class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12"
                      v-if="customer.legal_name"
                    >
                      <div class="data-block">
                        <span class="title-block">Legal Business Name</span>
                        <span class="content-block">{{
                          customer.legal_name
                        }}</span>
                      </div>
                    </div>

                    <div
                      class="col-xl-2 col-lg-2 col-md-2 col-sm-3 col-12"
                      v-if="customer.iata_code"
                    >
                      <div class="data-block">
                        <span class="title-block">IATA Code</span>
                        <span class="content-block">{{
                          customer.iata_code
                        }}</span>
                      </div>
                    </div>
                    <div
                      class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-12"
                      v-if="customer.vat_number"
                    >
                      <div class="data-block">
                        <span class="title-block">VAT Number</span>
                        <span class="content-block">{{
                          customer.vat_number
                        }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row mt-2" v-if="mode === 'edit'">
                  <div class="col-xl-12">
                    <div class="row">
                      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                        <base-input
                          v-capitalize
                          v-model.trim="$v.customer.company_name.$model"
                          label="Business Name"
                          placeholder="Business Name"
                          id="bussiness_name"
                          name="bussiness_name"
                          tabindex="1"
                          maxlength="45"
                          markrequired
                          :error="validateCompanyName($v.customer.company_name)"
                        />
                      </div>

                      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                        <base-input
                          v-capitalize
                          v-model.trim="$v.customer.legal_name.$model"
                          label="Legal Name"
                          placeholder="Legal Name"
                          id="bussiness_Legalname"
                          name="bussiness_Legalname"
                          tabindex="2"
                          maxlength="45"
                          :error="validateLegalName($v.customer.legal_name)"
                        />
                      </div>

                      <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                        <base-input
                          v-model.trim="$v.customer.iata_code.$model"
                          label="IATA Code"
                          placeholder="IATA Code"
                          id="bussiness_iata_code"
                          name="bussiness_iata_code"
                          tabindex="2"
                          maxlength="45"
                          :error="validateIataCode($v.customer.iata_code)"
                        />
                      </div>
                      <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                        <base-input
                          v-model.trim="$v.customer.vat_number.$model"
                          label="VAT Number"
                          placeholder="VAT Number"
                          id="bussiness_VatNumber"
                          name="bussiness_VatNumber"
                          tabindex="2"
                          maxlength="45"
                          :error="validateVatNumber($v.customer.vat_number)"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card">
                <h2 class="subtitle">Main Contact</h2>

                <div v-if="mode === 'view'">
                  <div class="row">
                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                      <div class="data-block">
                        <span class="title-block">Full Name</span>
                        <span class="content-block"
                          >{{ customer.first_name }}
                          {{ customer.last_name }}</span
                        >
                      </div>
                    </div>
                    <div
                      class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-12"
                      v-if="customer.gender"
                    >
                      <div class="data-block">
                        <span class="title-block">Gender</span>
                        <span class="content-block">{{
                          formatGenderLabel(customer.gender)
                        }}</span>
                      </div>
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-12">
                      <div class="data-block">
                        <span class="title-block">Contact Number</span>
                        <span class="content-block">
                          <a :href="`tel:${customer.phone}`">{{
                            customer.phone
                          }}</a>
                          <el-tooltip content="Copy" placement="bottom">
                            <span
                              class="curp ml-2"
                              v-clipboard:copy="customer.phone"
                              v-clipboard:success="onCopy"
                              v-clipboard:error="onErrorCopy"
                            >
                              <i class="flaticon-copy link ml-0"></i></span
                          ></el-tooltip>
                        </span>
                      </div>
                    </div>
                    <div
                      class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12"
                      v-if="customer.contact_info"
                    >
                      <div class="data-block">
                        <span class="title-block">Other Contact Info</span>
                        <span class="content-block">
                          <i
                            class="flaticon-bold-whatsapp f16 mr-1"
                            v-if="
                              customer.other_contact_platform === 'Whatsapp'
                            "
                          ></i>
                          <i
                            class="flaticon-bold-logotipo-de-skype f16 mr-1"
                            v-if="customer.other_contact_platform === 'Skype'"
                          ></i>

                          {{ customer.contact_info }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-xl-12 mt-2" v-if="mode === 'edit'">
                  <div class="row">
                    <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                      <base-input
                        v-capitalize
                        v-model.trim="$v.customer.first_name.$model"
                        label="First Name"
                        placeholder="First Name"
                        id="first_name"
                        name="first_name"
                        maxlength="45"
                        tabindex="1"
                        :focusact="true"
                        markrequired
                        :error="validateFirstName($v.customer.first_name)"
                      />
                    </div>

                    <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                      <base-input
                        v-capitalize
                        v-model.trim="$v.customer.last_name.$model"
                        label="Last Name"
                        placeholder="Last Name"
                        id="last_name"
                        name="last_name"
                        maxlength="45"
                        tabindex="2"
                        markrequired
                        :error="validateLastName($v.customer.last_name)"
                      />
                    </div>
                    <div
                      class="col-xl-2 col-lg-3 col-md-3 col-sm-6 col-12 form-group"
                      v-bind:class="{
                        'is-invalid': $v.customer.gender.$error
                      }"
                    >
                      <label for="title" class="title-label">Gender</label>
                      <b-form-group v-slot="{ ariaDescribedby }" class="mb-0">
                        <b-form-radio-group
                          v-model="$v.customer.gender.$model"
                          :aria-describedby="ariaDescribedby"
                          id="radio-gender"
                          name="radio-gender"
                          buttons
                          button-variant="outline-neutral"
                          size="md"
                          tabindex="3"
                        >
                          <b-form-radio value="male" class="pc-3" tabindex="3"
                            >Mr.</b-form-radio
                          >
                          <b-form-radio value="female" class="pc-3"
                            >Mrs.</b-form-radio
                          >
                          <b-form-radio value="other" class="pc-3"
                            >Mx.</b-form-radio
                          >
                        </b-form-radio-group>
                      </b-form-group>

                      <small
                        class="invalid-feedback mt-1"
                        v-if="$v.customer.gender.$error"
                        >Select</small
                      >
                    </div>

                    <div
                      class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12 inputphone form-group"
                    >
                      <label
                        class="title-label"
                        v-bind:class="{
                          'is-invalid': $v.customer.phone.$error
                        }"
                        ><span class="markrequired">*</span>Contact
                        Number</label
                      >
                      <vue-tel-input
                        v-model="phoneFormat"
                        key="NumberPhoneCustomer"
                        inputId="NumberPhoneCustomer"
                        name="NumberPhoneCustomer"
                        required
                        mode="international"
                        inputClasses="input no-label no-err"
                        :dynamicPlaceholder="true"
                        :disabledFetchingCountry="true"
                        :validCharactersOnly="true"
                        :wrapperClasses="[
                          $v.customer.phone.$error ? 'is-invalid' : '',
                          'mb-0'
                        ]"
                        @validate="phoneInput"
                        tabindex="6"
                      ></vue-tel-input>
                      <small
                        class="invalid-feedback mt-1"
                        v-if="$v.customer.phone.$error"
                        >Enter a valid Phone Number</small
                      >
                    </div>

                    <div class="col-xl-5 col-lg-4 col-md-4 col-sm-6 col-12">
                      <label class="title-label">Other Contact Info</label>
                      <div class="d-flex">
                        <b-form-group
                          v-slot="{ ariaDescribedby2 }"
                          class="d-inline-flex"
                        >
                          <b-form-radio-group
                            v-model="customer.other_contact_platform"
                            :aria-describedby="ariaDescribedby2"
                            id="radio-contact"
                            name="radio-contact"
                            tabindex="7"
                            buttons
                            button-variant="outline-neutral"
                            size="md"
                          >
                            <b-form-radio
                              value="Whatsapp"
                              class="pc-2"
                              title="Whatsapp"
                              tabindex="7"
                              ><i class="flaticon-bold-whatsapp f16"></i
                            ></b-form-radio>
                            <b-form-radio
                              value="Skype"
                              class="pc-2"
                              title="Skype"
                              ><i
                                class="flaticon-bold-logotipo-de-skype f16"
                              ></i
                            ></b-form-radio>
                          </b-form-radio-group>
                        </b-form-group>

                        <base-input
                          v-model.trim="customer.contact_info"
                          placeholder="Other Contact Info"
                          id="passengers_phone_optional"
                          name="passengers_phone_optional"
                          tabindex="8"
                          class="d-inline-flex"
                        >
                        </base-input>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card">
                <h2 class="subtitle">Account Info</h2>
                <div class="row" v-show="mode === 'view'">
                  <div class="col-xl-5 col-lg-5 col-md-5 col-sm-6 col-12">
                    <div class="data-block">
                      <span class="title-block">Email Address</span>
                      <span class="content-block">
                        <a
                          :href="
                            `https://mail.google.com/mail/?view=cm&fs=1&to=${customer.email}`
                          "
                          target="_blank"
                          >{{ customer.email }}</a
                        >
                        <el-tooltip content="Copy" placement="bottom">
                          <span
                            class="curp ml-2"
                            v-clipboard:copy="customer.email"
                            v-clipboard:success="onCopy"
                            v-clipboard:error="onErrorCopy"
                          >
                            <i class="flaticon-copy link ml-0"></i></span
                        ></el-tooltip>
                      </span>
                    </div>
                  </div>

                  <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                    <div class="data-block">
                      <span class="title-block">Register Source</span>
                      <span class="content-block">{{ source }}</span>
                    </div>
                  </div>

                  <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                    <div class="data-block">
                      <span class="title-block">Register Date/Time</span>
                      <span class="content-block">{{ created }}</span>
                    </div>
                  </div>
                </div>

                <div class="row mt-2" v-show="mode === 'edit'">
                  <div class="col-xl-12">
                    <div class="row">
                      <div class="col-xl-5 col-lg-6 col-md-6 col-sm-12 col-12">
                        <base-input
                          label="Email Address"
                          placeholder="Email Address"
                          id="customer_email"
                          name="customer_email"
                          maxlength="100"
                          tabindex="14"
                          format="lowercase"
                          autocomplete="off"
                          v-model.trim="$v.customer.email.$model"
                          markrequired
                          :error="validateEmailField($v.customer.email)"
                        />
                      </div>

                      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                        <div class="data-block">
                          <span class="title-block">Register Source</span>
                          <span class="content-block">{{ source }}</span>
                        </div>
                      </div>

                      <div class="col-xl-4 col-lg-3 col-md-3 col-sm-6 col-12">
                        <div class="data-block">
                          <span class="title-block">Register Date/Time</span>
                          <span class="content-block">{{ created }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card">
                <h2 class="subtitle">Address</h2>
                <div class="row" v-if="mode === 'view'">
                  <div
                    class="col-xl-12"
                    v-if="
                      customer.street ||
                        customer.city ||
                        customer.state ||
                        customer.zip_code ||
                        customer.country
                    "
                  >
                    <div class="row">
                      <div
                        class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12"
                        v-if="customer.street"
                      >
                        <div class="data-block">
                          <span class="title-block"
                            >Street address, apartment, suite, etc.:</span
                          >
                          <span class="content-block">{{
                            customer.street
                          }}</span>
                        </div>
                      </div>

                      <div
                        class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12"
                        v-if="customer.city"
                      >
                        <div class="data-block">
                          <span class="title-block">City</span>
                          <span class="content-block capitalize">{{
                            customer.city
                          }}</span>
                        </div>
                      </div>

                      <div
                        class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12"
                        v-if="customer.state"
                      >
                        <div class="data-block">
                          <span class="title-block">State/Province/Region</span>
                          <span class="content-block">{{
                            customer.state
                          }}</span>
                        </div>
                      </div>

                      <div
                        class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12"
                        v-if="customer.zip_code"
                      >
                        <div class="data-block">
                          <span class="title-block">Zip/Postal Code</span>
                          <span class="content-block">{{
                            customer.zip_code
                          }}</span>
                        </div>
                      </div>

                      <div
                        class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12"
                        v-if="customer.country"
                      >
                        <div class="data-block">
                          <span class="title-block">Country</span>
                          <span class="content-block">{{
                            customer.country
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-12" v-else>
                    <div class="data-block">
                      <span class="content-block">No Provided</span>
                    </div>
                  </div>
                </div>

                <div class="row mt-2" v-if="mode === 'edit'">
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                    <base-input
                      v-capitalize
                      v-model="$v.customer.street.$model"
                      label="Street address, apartment, suite, etc."
                      placeholder="Street address, apartment, suite, etc"
                      id="customer_street"
                      name="customer_street"
                      maxlength="200"
                      tabindex="9"
                      :error="validateStreet($v.customer.street)"
                    />
                  </div>

                  <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                    <base-input
                      v-capitalize
                      v-model="$v.customer.city.$model"
                      label="City"
                      placeholder="City"
                      id="customer_city"
                      name="customer_city"
                      maxlength="45"
                      tabindex="10"
                      :error="validateCity($v.customer.city)"
                    />
                  </div>

                  <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                    <base-input
                      v-capitalize
                      v-model="$v.customer.state.$model"
                      label="State/Province/Region"
                      placeholder="State/Province/Region"
                      id="customer_state"
                      name="customer_state"
                      maxlength="45"
                      tabindex="11"
                      :error="validateState($v.customer.state)"
                    />
                  </div>

                  <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12">
                    <base-input
                      v-model.trim="$v.customer.zip_code.$model"
                      label="Zip/Postal Code"
                      placeholder="Zip/Postal Code"
                      id="customer_zipcode"
                      name="customer_zipcode"
                      maxlength="45"
                      tabindex="12"
                      :error="validateZipCode($v.customer.zip_code)"
                    />
                  </div>

                  <div class="col-xl-4 col-lg-6 col-md-4 col-sm-4 col-12">
                    <WSelect
                      v-bind:class="{
                        'invalid-feedback': $v.customer.country.$error
                      }"
                      v-model="$v.customer.country.$model"
                      label="Country"
                      placeholder="Enter a Country"
                      id="customer_country"
                      name="customer_country"
                      tabindex="13"
                      filterable
                      remote
                      reserve-keyword
                      :remote-method="searchCountry"
                      :loading="loading"
                      clearable
                    >
                      <el-option
                        v-for="country in optionsCountries"
                        :value="country.name"
                        :label="country.name"
                        :key="country.name"
                      ></el-option>
                    </WSelect>
                  </div>
                </div>
              </div>
            </tab-pane>

            <tab-pane id="paymentInfo" title="Payment Info" ref="paymentInfo">
              <div class="card">
                <div v-if="mode === 'view'">
                  <div class="row">
                    <div class="col-xl-2 col-lg-2 col-md-3 col-sm-2 col-12">
                      <div class="data-block">
                        <span class="title-block">Markup</span>
                        <span class="content-block"
                          >{{ customer.mark_up }}%</span
                        >
                      </div>
                    </div>

                    <div class="col-xl-2 col-lg-2 col-md-3 col-sm-3 col-12">
                      <div class="data-block">
                        <span class="title-block">Commission</span>
                        <span class="content-block"
                          >{{ customer.commission }}%</span
                        >
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row mt-2 align-items-center" v-if="mode === 'edit'">
                  <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12">
                    <BaseNumberInput
                      v-model.number="$v.customer.mark_up.$model"
                      label="Markup"
                      placeholder="Markup"
                      id="customer_markup"
                      name="customer_markup"
                      maxlength="3"
                      tabindex="17"
                      class="input-append"
                      markrequired
                      @input="validateMarkup"
                      :error="validateMarkupField($v.customer.mark_up)"
                    >
                      <template slot="append">%</template>
                    </BaseNumberInput>
                  </div>

                  <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12">
                    <BaseNumberInput
                      v-model.number="$v.customer.commission.$model"
                      label="Commission"
                      placeholder="Commission"
                      id="commission"
                      name="commission"
                      maxlength="3"
                      class="input-append"
                      tabindex="19"
                      markrequired
                      :error="validateCommission($v.customer.commission)"
                    >
                      <template slot="append">%</template>
                    </BaseNumberInput>
                  </div>
                </div>
              </div>

              <div class="card">
                <div>
                  <div class="row mb-2">
                    <div class="col-6 align-self-center">
                      <h2 class="subtitle mb-0">Payment Methods</h2>
                    </div>
                    <div class="col-6 alinmov2 align-self-center">
                      <base-button
                        v-if="canUserCreate"
                        type="link"
                        class="min-button"
                        @click="createPaymentMethod()"
                      >
                        <i class="flaticon-plus"></i> Add new
                      </base-button>
                    </div>
                  </div>

                  <div class="row">
                    <div
                      class="col-12 mb-4"
                      v-if="paymentMethodsOptions.length === 0"
                    >
                      <base-alert type="warning" class="mb-1 info-min">
                        <i class="flaticon-warning mr-1"></i> There are no
                        payment methods here
                      </base-alert>
                    </div>

                    <div class="col-12" v-else>
                      <div
                        v-for="(option, index) in paymentMethodsOptions"
                        :key="index"
                        class="card card-shadow pb-2"
                      >
                        <div class="row">
                          <div
                            class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-12 align-self-center alinmov6"
                          >
                            <div
                              v-if="option.type === 'bank_account'"
                              class="mb-3"
                            >
                              <img
                                src="~rhomtrip_assets/src/img/icons/bank.png"
                                alt="bank"
                                class="icon-payment"
                              /><span class="d-block">
                                <strong>
                                  {{
                                    formatTransferTypeAbbr(option.type_transfer)
                                  }}</strong
                                ></span
                              >
                            </div>

                            <div v-else>
                              <img
                                src="~rhomtrip_assets/src/img/icons/paypal.png"
                                alt="bank"
                                class="icon-payment mb-3"
                              />
                            </div>
                          </div>

                          <div
                            class="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-12 align-self-center alinmov4"
                          >
                            <div class="data-block">
                              <h2 class="subtitle mb-0 d-md-inline d-sm-block">
                                {{ formatPaymentMethodType(option.type) }}
                                <span
                                  class="badge-status badge-default ml-2"
                                  v-if="option.default"
                                  >Default</span
                                >
                              </h2>

                              <div v-if="option.type === 'bank_account'">
                                <span class="content-block"
                                  ><strong
                                    >Account Holder / Business Name:</strong
                                  >
                                  {{ option.name_account }}
                                  <el-tooltip content="Copy" placement="bottom">
                                    <span
                                      class="curp ml-2"
                                      v-clipboard:copy="option.name_account"
                                      v-clipboard:success="onCopy"
                                      v-clipboard:error="onErrorCopy"
                                    >
                                      <i
                                        class="flaticon-copy link ml-0"
                                      ></i></span></el-tooltip
                                ></span>

                                <span class="content-block"
                                  ><strong>Type Transfer:</strong>
                                  {{ formatTransferType(option.type_transfer) }}
                                </span>

                                <span
                                  class="content-block"
                                  v-if="
                                    option.type_transfer === 'ach' ||
                                      option.type_transfer === 'wire'
                                  "
                                  ><strong>Account Type:</strong>
                                  {{ formatAccountType(option.account_type) }}
                                </span>

                                <span
                                  class="content-block"
                                  v-if="
                                    option.type_transfer === 'ach' ||
                                      option.type_transfer === 'wire'
                                  "
                                  ><strong
                                    v-if="option.type_transfer === 'ach'"
                                  >
                                    ACH Routing Number:</strong
                                  >
                                  <strong
                                    v-else-if="option.type_transfer === 'wire'"
                                  >
                                    Fedwire Routing Number:</strong
                                  >
                                  {{ option.routing_number }}
                                  <el-tooltip content="Copy" placement="bottom">
                                    <span
                                      class="curp ml-2"
                                      v-clipboard:copy="option.routing_number"
                                      v-clipboard:success="onCopy"
                                      v-clipboard:error="onErrorCopy"
                                    >
                                      <i
                                        class="flaticon-copy link ml-0"
                                      ></i></span
                                  ></el-tooltip>
                                </span>

                                <span
                                  class="content-block"
                                  v-if="option.type_transfer === 'swift'"
                                  ><strong>SWIFT Code / BIC Code:</strong>
                                  {{ option.swift_code }}
                                  <el-tooltip content="Copy" placement="bottom">
                                    <span
                                      class="curp ml-2"
                                      v-clipboard:copy="option.swift_code"
                                      v-clipboard:success="onCopy"
                                      v-clipboard:error="onErrorCopy"
                                    >
                                      <i
                                        class="flaticon-copy link ml-0"
                                      ></i></span></el-tooltip
                                ></span>

                                <span
                                  class="content-block"
                                  v-if="option.type_transfer === 'transfer_gbp'"
                                  ><strong>UK Sort Code:</strong>
                                  {{ option.uk_sort_code }}
                                  <el-tooltip content="Copy" placement="bottom">
                                    <span
                                      class="curp ml-2"
                                      v-clipboard:copy="option.uk_sort_code"
                                      v-clipboard:success="onCopy"
                                      v-clipboard:error="onErrorCopy"
                                    >
                                      <i
                                        class="flaticon-copy link ml-0"
                                      ></i></span></el-tooltip
                                ></span>

                                <span class="content-block">
                                  <strong
                                    v-if="
                                      option.type_transfer === 'transfer_eur'
                                    "
                                    >IBAN:</strong
                                  >
                                  <strong
                                    v-else-if="option.type_transfer === 'swift'"
                                    >IBAN / Account Number:</strong
                                  >
                                  <strong v-else>Account Number:</strong>

                                  {{ option.account_number }}
                                  <el-tooltip content="Copy" placement="bottom">
                                    <span
                                      class="curp ml-2"
                                      v-clipboard:copy="option.account_number"
                                      v-clipboard:success="onCopy"
                                      v-clipboard:error="onErrorCopy"
                                    >
                                      <i
                                        class="flaticon-copy link ml-0"
                                      ></i></span></el-tooltip
                                ></span>

                                <span class="content-block"
                                  ><strong>Recipient Address:</strong>
                                  {{
                                    formatAddress(
                                      option.address,
                                      option.city,
                                      option.post_code,
                                      option.country
                                    )
                                  }}
                                  <el-tooltip content="Copy" placement="bottom">
                                    <span
                                      class="curp ml-2"
                                      v-clipboard:copy="
                                        formatAddress(
                                          option.address,
                                          option.city,
                                          option.post_code,
                                          option.country
                                        )
                                      "
                                      v-clipboard:success="onCopy"
                                      v-clipboard:error="onErrorCopy"
                                    >
                                      <i
                                        class="flaticon-copy link ml-0"
                                      ></i></span></el-tooltip
                                ></span>
                              </div>
                              <div v-else>
                                <span class="content-block"
                                  ><strong>Account:</strong> {{ option.email }}

                                  <el-tooltip content="Copy" placement="bottom">
                                    <span
                                      class="curp ml-2"
                                      v-clipboard:copy="option.email"
                                      v-clipboard:success="onCopy"
                                      v-clipboard:error="onErrorCopy"
                                    >
                                      <i
                                        class="flaticon-copy link ml-0"
                                      ></i></span></el-tooltip
                                ></span>
                              </div>
                            </div>
                          </div>

                          <div
                            class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-12 align-self-center mb-3 alinmov6"
                          >
                            <el-tooltip content="Edit" placement="bottom">
                              <span
                                class="icon-action ml-2"
                                @click="editPaymentMethodByIndex(option, index)"
                              >
                                <i class="flaticon-pencil text-primary"></i>
                              </span>
                            </el-tooltip>

                            <el-tooltip
                              content="Mark by default"
                              placement="bottom"
                            >
                              <span
                                class="icon-action ml-2"
                                @click="makePaymentMethodAsDefault(index)"
                                v-if="!option.default"
                              >
                                <i class="flaticon-bold-button text-new"></i>
                              </span>
                            </el-tooltip>

                            <el-tooltip content="Delete" placement="bottom">
                              <span
                                class="icon-action ml-2"
                                @click="deletePaymentMethod(index)"
                              >
                                <i class="flaticon-delete text-danger"></i>
                              </span>
                            </el-tooltip>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <ManagePaymentMethod
                :show="showPaymentMethodModal"
                :paymentMethod="paymentMethod"
                :type="paymentMethodType"
                @addPaymentMethod="addPaymentMethod"
                @editPaymentMethod="editPaymentMethod"
                @closeModal="closePaymentMethodModal"
              />
            </tab-pane>

            <tab-pane id="Metrics" title="Metrics" ref="Metrics">
              <Reservations v-if="resellerId" :resellerId="resellerId" />
            </tab-pane>

            <tab-pane id="Settings" title="Settings" ref="Settings">
              <div class="mt-2" v-if="resellerId">
                <ResellerApiKeys :resellerId="resellerId" />
                <ResellerProductAccess :resellerId="resellerId" />
              </div>
            </tab-pane>
          </tabs>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapMutations, mapActions } from "vuex";
import {
  required,
  minLength,
  maxLength,
  email,
  numeric,
  decimal,
  between,
  helpers
} from "vuelidate/lib/validators";
const ValName = helpers.regex("alphaCha", /^[a-zA-ZÑñáéíóúüüÜÁÉÍÓÚ'-\s]*$/);
import { AuthAPI, ResellersAPI } from "../../../core/api";
import Swal from "sweetalert2";
import { VueTelInput } from "vue-tel-input";
import WSelect from "@/components/Select";
import moment from "moment-timezone";
import lodash from "lodash";
import ManagePaymentMethod from "../components/ManagePaymentMethod.vue";
import Reservations from "../components/Reservations.vue";
import ResellerApiKeys from "../components/ResellerApiKeys.vue";
import ResellerProductAccess from "../components/ResellerProductAccess.vue";
import Pusher from "pusher-js";
import ShortUniqueId from "short-unique-id";
import {
  goBack,
  isUserAuthorized,
  setSigOut
} from "../../../helpers/commons.helpers";
import { FileService } from "../../../core/services";
import {
  formatGenderLabel,
  formatPaymentMethodType,
  formatTransferType,
  formatTransferTypeAbbr,
  formatAccountType,
  formatAddress,
  formatDate
} from "../services/format.service";
import {
  validateCompanyName,
  validateLegalName,
  validateIataCode,
  validateVatNumber,
  validateFirstName,
  validateLastName,
  validateEmailField,
  validateStreet,
  validateCity,
  validateState,
  validateZipCode,
  validateMarkupField,
  validateCommission
} from "../services/validation.resellers";

export default {
  name: "ResellerProfile",
  data() {
    return {
      customer: {
        first_name: "",
        last_name: "",
        full_name: "",
        email: "",
        phone: "",
        type: "ota",
        company_name: "",
        legal_name: "",
        iata_code: "",
        vat_number: "",
        country: "",
        city: "",
        state: "",
        zip_code: "",
        street: "",
        notes: "",
        mark_up: 34,
        type_markup: "markup",
        type_charge: "commission",
        commission: 10,
        gender: "other",
        contact_info: "",
        other_contact_platform: "",
        currency: {
          code: "USD",
          symbol: "$",
          label: "US Dollar"
        },
        source: "rhomtrip",
        url_picture: ""
      },
      loading: false,
      optionsCountries: [],
      saved: false,
      customerCopy: {},
      lastEmail: "",
      created: "",
      source: "rhombuss",
      customerStatus: false,
      picture: "",
      imageProfile: require("rhomtrip_assets/src/img/users/user-placeholder.png"),
      tabActive: "Overview",
      resellerId: null,
      resellerType: "",
      phoneFormat: "",
      mode: "view",
      paymentMethods: [],
      paymentMethodsOptions: [],
      showPaymentMethodModal: false,
      paymentMethod: null,
      paymentMethodIndex: 0,
      paymentMethodType: "create",
      pusher: null
    };
  },
  components: {
    VueTelInput,
    WSelect,
    ManagePaymentMethod,
    Reservations,
    ResellerApiKeys,
    ResellerProductAccess
  },
  async created() {
    var bread = [
      {
        text: "Dashboard",
        to: "/dashboard"
      },
      {
        text: "Resellers",
        to: "/resellers"
      },
      {
        text: "Reseller Profile",
        active: true
      }
    ];
    Pusher.logToConsole = process.env.VUE_APP_ENV === "development";
    this.pusher = new Pusher(process.env.VUE_APP_PUSHER_API_KEY, {
      cluster: process.env.VUE_APP_PUSHER_CLUSTER
    });
    this.setItemsBread(bread);
    await this.getReseller(this.$route.params.id);
    this.controllingChanges("customers");
  },
  methods: {
    async getReseller(resellerId, loader = true) {
      try {
        this.setLoad(loader);
        let { data } = await ResellersAPI.getResellerById(
          resellerId,
          this.sesion.token
        );
        this.setLoad(false);
        if (data) {
          let reseller = data;
          this.resellerType = reseller.type;
          this.resellerId = reseller._id;
          this.customer.first_name = reseller.first_name;
          this.customer.last_name = reseller.last_name;
          this.customer.company_name = reseller.company_name;
          this.customer.vat_number = reseller.vat_number;
          this.customer.email = reseller.email;
          this.$v.customer.email.$model = reseller.email;
          this.lastEmail = reseller.email;
          this.customer.type_markup = reseller.type_markup;
          this.customer.phone = reseller.phone;
          this.phoneFormat = `${this.customer.phone}`;

          this.customer.gender = reseller.gender;
          this.customer.country = reseller.country;
          this.customer.city = reseller.city;
          this.customer.state = reseller.state;
          this.customer.zip_code = reseller.zip_code;
          this.customer.street = reseller.street;
          this.customer.notes = reseller.notes;
          this.customer.mark_up = reseller.mark_up;
          this.customer.type_charge = reseller.type_charge;
          this.customer.commission = reseller.commission;
          this.customer.type = reseller.type;

          this.customer.contact_info = reseller.contact_info;
          this.customer.other_contact_platform =
            reseller.other_contact_platform;

          this.paymentMethods = reseller.payment_methods
            ? reseller.payment_methods
            : [];
          this.paymentMethodsOptions = this.moveElementToFirst(
            this.paymentMethods
          );
          this.customer.status = reseller.status;
          this.customer.source = reseller.source;
          this.customer.url_picture = reseller.url_picture;
          this.customer.legal_name = reseller.legal_name;
          this.customer.iata_code = reseller.iata_code;

          this.source =
            ["rhomtrip", "rhombuss"].indexOf(reseller.source) > -1
              ? "RhomTrip"
              : "Web";
          this.customerStatus = true;
          this.created = moment(reseller.created_at).format(
            "DD MMM. YYYY - hh:mm A"
          );
          this.customerCopy = lodash.cloneDeep(this.customer);
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message:
              "There was an error loading the Reseller, please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "There was an error loading the Reseller, please try again"
        );
      }
    },
    goToPreviousPage() {
      goBack(this);
    },
    onCopy() {
      this.$notify({
        type: "success",
        title: "Success!",
        message: "The text has been copied to the clipboard",
        icon: "flaticon-check-3"
      });
    },
    onErrorCopy() {
      this.$notify({
        type: "danger",
        title: "Error!",
        message: "The text couldn't be copied",
        icon: "flaticon-remove"
      });
    },
    async readFile(event) {
      const [file] = event.target.files;
      if (!file) return;

      const MAX_SIZE = 2 * 1024 * 1024;
      if (file.size > MAX_SIZE) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The image cannot exceed 2MB",
          icon: "flaticon-remove"
        });
        event.target.value = "";
        return;
      }

      try {
        const fileData = FileService.generateResourceData(
          "/users/avatars",
          file.name
        );
        const queryString = FileService.buildQueryString(fileData);
        const urlFile = await FileService.uploadResource(file, queryString);
        if (urlFile) {
          this.customer.url_picture = urlFile;
          this.picture = urlFile;
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The image could not be uploaded. Please try again.",
            icon: "flaticon-remove"
          });
          event.target.value = "";
        }
      } catch {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The image could not be uploaded. Please try again.",
          icon: "flaticon-remove"
        });
        event.target.value = "";
      }
    },
    clearfile() {
      this.customer.url_picture = "";
      this.picture = "";
    },
    handleError(error, message) {
      if (error.response) {
        let { data } = error.response;
        if (data.code === 401) {
          let auth = setSigOut(error);
          if (auth) {
            this.setSigOut(true);
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: message,
          icon: "flaticon-remove"
        });
      }
    },
    searchCountry(value) {
      if (value !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.optionsCountries = this.countries.filter(country => {
            return country.name.toLowerCase().indexOf(value.toLowerCase()) > -1;
          });
        }, 100);
      } else {
        this.optionsCountries = [];
      }
    },
    phoneInput(payload) {
      let result = payload;
      if (result.isValid) {
        this.customer.phone = result.number.e164;
      } else {
        this.customer.phone = "";
      }
    },
    validateMarkup(value) {
      if (parseFloat(value) < 0) {
        this.customer.mark_up = 0;
      }
    },
    async saveReseller(route = null) {
      try {
        if (!this.$v.customer.$invalid) {
          var reseller = lodash.cloneDeep(this.customer);
          reseller.full_name = `${reseller.first_name} ${reseller.last_name}`;
          reseller.email = reseller.email.toLowerCase();
          await this.updateResellerById(this.resellerId, reseller, route);
        } else {
          this.$v.customer.$touch();
          this.$notify({
            type: "warning",
            title: "Important!",
            message: "Please complete the required attributes",
            icon: "flaticon-warning-1"
          });
        }
      } catch (error) {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "Please complete the required attributes",
          icon: "flaticon-warning-1"
        });
      }
    },
    async updateResellerById(resellerId, reseller, route = null) {
      try {
        this.setLoad(true);
        let { data } = await ResellersAPI.updateResellerById(
          resellerId,
          reseller,
          this.sesion.token
        );
        this.setLoad(false);
        this.saved = true;
        if (data) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Reseller has been Saved",
            icon: "flaticon-check-3"
          });
          if (route) {
            this.$router.push(route);
          } else {
            this.mode = "view";
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "There was an error saving the Reseller, please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "There was an error saving the Reseller, please try again",
          icon: "flaticon-remove"
        });
      }
    },
    openPaymentMethodModal() {
      this.showPaymentMethodModal = true;
    },
    closePaymentMethodModal() {
      this.showPaymentMethodModal = false;
      this.paymentMethodIndex = 0;
      this.paymentMethodType = "create";
      this.paymentMethod = null;
    },
    createPaymentMethod() {
      this.paymentMethodIndex = 0;
      this.paymentMethodType = "create";
      this.paymentMethod = null;
      this.openPaymentMethodModal();
    },
    async addPaymentMethod(paymentMethod) {
      if (this.paymentMethods.length === 0) {
        paymentMethod.default = true;
        this.paymentMethods.push(paymentMethod);
      } else {
        this.paymentMethods.push(paymentMethod);
      }
      await this.updatePaymentMethodByResellerId(
        this.resellerId,
        { payment_methods: this.paymentMethods },
        "The Payment Method has been Added"
      );
      this.paymentMethodsOptions = this.paymentMethods;
    },
    async makePaymentMethodAsDefault(paymentMethodIndex) {
      this.paymentMethods.forEach((paymentMethod, index) => {
        paymentMethod.default = index === paymentMethodIndex;
      });
      await this.updatePaymentMethodByResellerId(
        this.resellerId,
        { payment_methods: this.paymentMethods },
        "The Payment Method has been Updated"
      );
      this.paymentMethodsOptions = this.moveElementToFirst(this.paymentMethods);
    },
    async deletePaymentMethod(index) {
      let { value } = await Swal.fire({
        title: "Delete Payment Method",
        text: "Are you sure do you want to delete this Payment Method?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",
        confirmButtonText: "Yes",
        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        this.paymentMethods.splice(index, 1);
        if (this.paymentMethods.length === 1) {
          this.paymentMethods[0].default = true;
        }
        await this.updatePaymentMethodByResellerId(
          this.resellerId,
          { payment_methods: this.paymentMethods },
          "The Payment Method has been Deleted"
        );
        this.paymentMethodsOptions = this.paymentMethods;
      }
    },
    editPaymentMethodByIndex(option, index) {
      this.paymentMethodIndex = index;
      this.paymentMethodType = "edit";
      this.paymentMethod = option;
      this.openPaymentMethodModal();
    },
    async editPaymentMethod(paymentMethod) {
      if (paymentMethod) {
        this.paymentMethods.splice(this.paymentMethodIndex, 1, paymentMethod);
      }
      await this.updatePaymentMethodByResellerId(
        this.resellerId,
        { payment_methods: this.paymentMethods },
        "The Payment Method has been Updated"
      );
      this.paymentMethodsOptions = this.paymentMethods;
      this.paymentMethodIndex = 0;
      this.paymentMethodType = "create";
      this.paymentMethod = null;
    },
    async verifyEmailCustomer(email) {
      try {
        if (email) {
          let { data } = await AuthAPI.checkUniqueEmail(email.toLowerCase());
          if (data.status) {
            return !data.data.status;
          }
        }
        return false;
      } catch (error) {
        return false;
      }
    },
    validateEmail(email) {
      return /^[\w+\-\.]+@[\w-]+(\.[a-zA-Z]{2,}){1,}$/.test(email);
    },
    changeTabActive(tabActive) {
      this.tabActive = tabActive;
    },
    isInResellerModule(modules = []) {
      if (!(modules.indexOf("resellers") > -1)) {
        this.setResellerSearchCriteria({
          currentPage: 1,
          limit: 15,
          query: "",
          status: false
        });
      }
    },
    async detectChanges(from, to, next) {
      let isEqual = lodash.isEqual(this.customer, this.customerCopy);
      if (!isEqual && !this.saved && this.canUserUpdate) {
        let { value, dismiss } = await Swal.fire({
          title: "Important",
          html:
            "The Reseller has been modified. <br> Do you want to save changes?",
          imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
          buttonsStyling: false,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          reverseButtons: true,
          cancelButtonText: "No",
          confirmButtonText: "Yes",
          confirmButtonClass: "btn btn-primary btn-small-one"
        });
        if (value) {
          this.saveReseller(to.path);
        } else if (dismiss === Swal.DismissReason.cancel) {
          next();
        }
      } else {
        next();
      }
    },
    async updatePaymentMethodByResellerId(
      resellerId,
      paymentMethods,
      successMessage
    ) {
      try {
        let { data } = await ResellersAPI.patchResellerById(
          resellerId,
          paymentMethods,
          this.sesion.token
        );
        if (data) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: successMessage,
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message:
              "There was an error saving the Payment Method, please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message:
            "There was an error saving the Payment Method, please try again",
          icon: "flaticon-remove"
        });
      }
    },
    moveElementToFirst(paymentMethods = []) {
      let index = paymentMethods
        .map(paymentMethod => paymentMethod.default)
        .indexOf(true);
      if (index > -1) {
        let paymentMethod = paymentMethods[index];
        paymentMethods.splice(index, 1);
        paymentMethods.unshift(paymentMethod);
      }
      return paymentMethods;
    },
    controllingChanges(event) {
      var channel = this.pusher.subscribe("rhombuss");
      channel.bind(event, async data => {
        let { customerId } = data.customer;
        if ([this.resellerId].includes(customerId)) {
          await this.getReseller(this.resellerId, false);
        }
      });
    },
    validateCompanyName,
    validateLegalName,
    validateIataCode,
    validateVatNumber,
    validateFirstName,
    validateLastName,
    validateEmailField,
    validateStreet,
    validateCity,
    validateState,
    validateZipCode,
    validateMarkupField,
    validateCommission,
    formatGenderLabel,
    formatPaymentMethodType,
    formatTransferType,
    formatTransferTypeAbbr,
    formatAccountType,
    formatAddress,
    formatDate,
    ...mapMutations([
      "setLoad",
      "setItemsBread",
      "setResellerSearchCriteria",
      "setSigOut"
    ])
  },
  computed: {
    ...mapGetters(["countries", "sesion", "userRole", "load"]),
    canUserUpdate() {
      return isUserAuthorized("RESELLERS", this.userRole, "UPDATE");
    },
    canUserCreate() {
      return isUserAuthorized("RESELLERS", this.userRole, "CREATE");
    }
  },
  validations() {
    return {
      customer: {
        first_name: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(45),
          ValName
        },
        last_name: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(45),
          ValName
        },
        company_name: {
          required,
          minLength: minLength(3),
          maxLength: maxLength(45)
        },
        legal_name: {
          minLength: minLength(3),
          maxLength: maxLength(45)
        },
        iata_code: {
          minLength: minLength(5),
          maxLength: maxLength(25)
        },
        vat_number: {
          minLength: minLength(5),
          maxLength: maxLength(25)
        },
        mark_up: {
          numeric,
          decimal,
          between: between(0, 100)
        },
        email: {
          required,
          email,
          customValidator: async function(value) {
            if (this.validateEmail(value)) {
              if (this.lastEmail !== value) {
                return await this.verifyEmailCustomer(value);
              }
              return true;
            }
            return false;
          }
        },
        gender: {
          required
        },
        phone: {
          required,
          minLength: minLength(7),
          maxLength: maxLength(25)
        },
        country: {
          minLength: minLength(3),
          maxLength: maxLength(50)
        },
        city: {
          minLength: minLength(3),
          maxLength: maxLength(50)
        },
        state: {
          minLength: minLength(3),
          maxLength: maxLength(50)
        },
        zip_code: {
          minLength: minLength(4),
          maxLength: maxLength(10)
        },
        street: {
          minLength: minLength(5),
          maxLength: maxLength(100)
        },
        notes: {
          maxLength: maxLength(200)
        },
        commission: {
          numeric,
          decimal,
          between: between(0, 100)
        }
      }
    };
  },
  destroyed() {
    if (this.pusher !== null) {
      this.pusher.disconnect();
    }
  },
  beforeRouteLeave(to, from, next) {
    this.isInResellerModule(to.meta.modules);
    this.detectChanges(from, to, next);
  },
  beforeRouteUpdate(to, from, next) {
    this.isInResellerModule(to.meta.modules);
    this.detectChanges(from, to, next);
  }
};
</script>
